<template>
<div class="chapter">
<div class="inner_page">
      ﻿



<title></title>
<link href="PSWD.css" rel="stylesheet" type="text/css"/>
<p class="paranoindent1"> </p>
<h1><a id="p6"></a><a href="#/04_Contents#toc-introduction" id="introduction"><span class="un"><big>I</big>NTRODUCTION</span></a></h1>
<p class="paranoindent1"> </p>
<p class="paranoindent1"> </p>
<p class="paranoindent1"><span class="drop-cap2">T</span>he battles of Quatre Bras and Ligny have always been overshadowed by the great battle that took place two days later. Nevertheless, the events of 16 June 1815 were crucial, as Napoleon thereby missed his only real chance of achieving a decisive victory in this campaign. Had d’Erlon’s corps not meandered meaninglessly between the two battlefields that day, its involvement in either would surely have settled the issue for Napoleon.</p>
<p class="paraindent1">Wellington, surely the greatest tactical general of the era, held his own at Quatre Bras against numerous assaults from Marshal Ney’s determined French veterans. For much of the day, Wellington’s force was outnumbered and hung on by the skin of its teeth. It should be added that the fact that this strategic crossroads had not fallen to the French earlier can be attributed to the much-maligned Prince of Orange and the Netherlands generals that disobeyed Wellington’s earlier order to abandon their posts here.</p>
<p class="paraindent1">The fighting at Ligny was particularly bitter, with Blücher’s inexperienced Prussians giving little mercy and being shown even less during the murderous street fighting. Bruised and battered, the Prussian army fell back in a state of confusion on Wavre. Gneisenau and his staff officers then set about turning a tactical defeat into a strategic victory.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 05_Introduction.vue?7ba411fa